module.exports = __webpack_public_path__ + "media/hand-help.36b43c40.mp4";